import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { User } from '@macs-frontend/features/shared';

@Component({
  selector: 'md-dropdown-user-option',
  templateUrl: 'dropdown-user-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownUserOptionComponent extends BaseComponent {
  @Input()
  // @ts-expect-error
  user: User;
}
